import algoliasearch from 'algoliasearch';

const algoliaClient = algoliasearch(
  'R7QMR1R0H1',
  '19cbb4df88931854ac61073984b5755b'
);

export default algoliaClient;
